import * as React from 'react';
import clsx from 'clsx';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */

function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.strict,
      strict = _a === void 0 ? true : _a,
      _b = options.errorMessage,
      errorMessage = _b === void 0 ? 'useContext: `context` is undefined. Seems you forgot to wrap component within the Provider' : _b,
      name = options.name;
  var Context = /*#__PURE__*/React.createContext(undefined);
  Context.displayName = name;

  function useContext() {
    var _a;

    var context = React.useContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = 'ContextError';
      (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
}

var _a;
var CollapsibleContextProvider = (_a = createContext(), _a[0]), useCollapsibleContext = _a[1];

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Collapsible-module_collapsibleTrigger__YEbIs{display:flex;align-items:center;justify-content:space-between;border:1px solid #ededed;border-right:none;border-left:none;width:100%;background:transparent;padding:18px 16px;font-size:16px;font-weight:600;cursor:pointer}.Collapsible-module_collapsibleChevron__Tk9-x{transition:transform .3s;flex:0 0 30px}.Collapsible-module_collapsibleTrigger__YEbIs[aria-disabled=true]{cursor:not-allowed;background-color:var(--color-surface-subdued);color:var(--color-text-subdued)}.Collapsible-module_collapsibleTrigger__YEbIs[aria-expanded=true] .Collapsible-module_collapsibleChevron__Tk9-x{transform:rotate(180deg)}.Collapsible-module_collapsibleContentHidden__3ZpZR{display:none}";
var styles = {"collapsibleTrigger":"Collapsible-module_collapsibleTrigger__YEbIs","collapsibleChevron":"Collapsible-module_collapsibleChevron__Tk9-x","collapsibleContentHidden":"Collapsible-module_collapsibleContentHidden__3ZpZR"};
styleInject(css_248z);

var ChevronDown = function () {
    return (React.createElement("svg", { className: styles.collapsibleChevron, width: "16", height: "10", viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M15 1.43994L8 8.43994L1 1.43994", stroke: "#52575C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/


var NAME = 'Primitive';
var DEFAULT_TAG = 'div';
var Primitive = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var _a = props.as,
      Comp = _a === void 0 ? DEFAULT_TAG : _a,
      primitiveProps = __rest(props, ["as"]);

  return /*#__PURE__*/React.createElement(Comp, __assign({}, primitiveProps, {
    ref: forwardedRef
  }));
});
Primitive.displayName = NAME;

var COLLAPSIBLE_TRIGGER_NAME = 'CollapsibleTrigger';
var COLLAPSIBLE_TRIGGER_DEFAULT_TAG = 'button';
var CollapsibleTrigger = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.as, as = _b === void 0 ? COLLAPSIBLE_TRIGGER_DEFAULT_TAG : _b;
    var _c = useCollapsibleContext(), internalIsOpen = _c.internalIsOpen, setInternalIsOpen = _c.setInternalIsOpen, open = _c.open, onToggle = _c.onToggle, disabled = _c.disabled;
    var onClick = function () {
        if (!disabled) {
            typeof onToggle === 'undefined'
                ? setInternalIsOpen(!internalIsOpen)
                : onToggle(!open);
        }
    };
    return (React.createElement(Primitive, { ref: ref, as: as, onClick: onClick, className: clsx(styles.collapsibleTrigger, className), "aria-expanded": typeof open === 'undefined' ? internalIsOpen : open, "aria-disabled": disabled }, children));
});
CollapsibleTrigger.displayName = COLLAPSIBLE_TRIGGER_NAME;

var COLLAPSIBLE_CONTENT_NAME = 'CollapsibleContent';
var CollapsibleContent = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, as = _a.as, unmount = _a.unmount;
    var _b = useCollapsibleContext(), internalIsOpen = _b.internalIsOpen, open = _b.open;
    var currentOpen = typeof open === 'undefined' ? internalIsOpen : open;
    var internalClass = !currentOpen && styles.collapsibleContentHidden;
    return (React.createElement(React.Fragment, null, (!unmount || currentOpen) && (React.createElement(Primitive, { ref: ref, as: as, className: clsx(internalClass, className) }, children))));
});
CollapsibleContent.displayName = COLLAPSIBLE_CONTENT_NAME;

var Collapsible = function (_a) {
    var _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b, open = _a.open, onToggle = _a.onToggle, _c = _a.disabled, disabled = _c === void 0 ? false : _c, children = _a.children, props = __rest$1(_a, ["defaultOpen", "open", "onToggle", "disabled", "children"]);
    var _d = React.useState(defaultOpen), internalIsOpen = _d[0], setInternalIsOpen = _d[1];
    return (React.createElement(CollapsibleContextProvider, { value: {
            internalIsOpen: internalIsOpen,
            setInternalIsOpen: setInternalIsOpen,
            open: open,
            onToggle: onToggle,
            disabled: disabled,
        } },
        React.createElement("div", __assign$1({}, props), children)));
};

export { Collapsible, CollapsibleContent, ChevronDown as CollapsibleIcon, CollapsibleTrigger };
